import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { AccessGroupOption } from './hooks/useDestinationAccessGroups';
import type { UseCreateTemplateFormResult } from './hooks/useCreateTemplateForm';

type CreateTemplateState = {
  isHubertAdmin: boolean;
  form: UseCreateTemplateFormResult;
  accessGroupOptions: AccessGroupOption[];
};

type CreateTemplateProviderProps = {
  children: ReactNode;
  state: CreateTemplateState;
};

const CreateTemplateStateContext = createContext<CreateTemplateState | null>(null);

export const CreateTemplateProvider = ({ children, state }: CreateTemplateProviderProps) => {
  return <CreateTemplateStateContext.Provider value={state}>{children}</CreateTemplateStateContext.Provider>;
};

export const useCreateTemplateState = () => {
  const context = useContext(CreateTemplateStateContext);
  if (!context) {
    throw new Error('useCreateTemplateState must be used within CreateTemplateProvider');
  }
  return context;
};
